import { __makeTemplateObject } from "tslib";
import { css, palette2, spacing } from '../../../../foundation';
export var AccordionDetailsStyle = function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-top: 1px solid ", ";\n    padding: ", ";\n  "], ["\n    border-top: 1px solid ", ";\n    padding: ", ";\n  "])), palette2('neutral', 'l02'), spacing(4));
};
var templateObject_1;
